import React, { useRef, useState } from "react";
import ReactPlayer from "react-player";
import "./NotifyGreetings.css";
// import PriceTag from "../../../../../../assets/images/tagPrice.PNG";
import { Markup } from "interweave";
import PriceTag from "../../../../../assets/images/tagPrice.PNG";

import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import axios from "axios";
import swal from "sweetalert";
import noImage from "../../../../../assets/images/settings/no-image.png";
import { serverInfo } from "../../../../../App";
import { useContext } from "react";
import useFileHandleS3 from "../../../../../CustomHooks/useFileHandleS3";
import useVdieoHandleS3 from "../../../../../CustomHooks/useVideoHandleS3";
import MediaUploadProgressBar from "../../../../../Screen/MediaUploadProgressBar";
import useVideoHandleWithCompress from "../../../../../CustomHooks/useVideoHandleWithCompress";

const NotifyGreetingsContent = ({ greeting, getGreetingStatus }) => {
  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);

  const [pageNum, setPageNum] = useState(1);
  const [videoFile, setVideoFile] = useState(videoCdnUrl + greeting.video);
  const [imagedata, setImagedata] = useState("");
  const [videoData, setVideoData] = useState("");
  const [convertedContent, setConvertedContent] = useState(
    greeting.instruction ? greeting.instruction : null
  );
  const [loading, setLoading] = useState(false);

  // Image File
  const fileInputRef = useRef(null);
  const [filePath, setFilePath] = useState(greeting?.banner);
  const [file, setFile] = useState("");
  const [delKey, setDelKey] = useState(null);
  const [fileUrl, fileKey, progress] = useFileHandleS3(file, 'greetings/images', delKey);

  // Video File Handle
  const videoInputRef = useRef(null);
  const [videoPath, setVideoPath] = useState(greeting?.video);
  const [video, setVideo] = useState('');
  const [videoDelKey, setVideoDelKey] = useState(null);
  const [videoUrl, videoKey, videoProgress, videoHeight,videoWidth] = useVideoHandleWithCompress(video, 'greetings/videos', videoDelKey);

  const [inputData, setInputData] = useState({
    title: greeting.title,
    cost: greeting.cost,
    user_required_day: greeting.user_required_day,
    share_cost: greeting.share_cost,
    // star_ids: [],
    error_list: [],
  });

  // normal Input
  const handleInput = (e) => {
    e.persist();
    setInputData({ ...inputData, [e.target.name]: e.target.value });
  };

  // Banner Handle
  const bannerHandler = (file) => {
    setDelKey(fileKey);
    setFile(file[0]);
  };
  const deleteFile = () => {
    setFile(null);
    setDelKey(fileKey);
    fileInputRef.current.value = '';

  }
  // Video Handle
  const handleVideoChange = (file) => {
    setVideoDelKey(videoKey);
    setVideo(file[0]);
  };

  const deleteVideo = () => {
    setVideo('');
    setVideoDelKey(videoKey);
    videoInputRef.current.value = '';
  }

  const greetingSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const fData = new FormData();
    fData.append("banner", fileKey ? fileKey: filePath);
    fData.append("video", videoKey ? videoKey: videoPath);
    fData.append("id", greeting.id);
    fData.append("title", inputData.title);
    fData.append("cost", inputData.cost);
    fData.append("share_cost", inputData.share_cost);
    fData.append("user_required_day", inputData.user_required_day);
    fData.append("instruction", convertedContent);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.post(`/api/star/edit_greetings`, fData).then((res) => {
        if (res.data.status === 200) {
          swal("Success", res.data.message, "success");
          getGreetingStatus();
          setPageNum(1);
        } else if (res.data.status === 422) {
          setInputData({
            ...inputData,
            error_list: res.data.validation_errors,
          });
        } else {
          // swal("Error", res.data.message, "error");
        }
        setLoading(false);
      });
    });
  };
  const approveNow = () => {
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.get(`/api/star/approve_greeting/${greeting.id}`).then((res) => {
        setLoading(false);
        if (res.data.status === 200) {
          if (file) {
            setFile('');
            setDelKey(filePath.split("com/").pop())
          }
          if (video) {
            setVideo('');
            setVideoDelKey(videoPath.split("com/").pop())
          }

          swal("Success", res.data.message, "success");
          // history.push(`/superstar-admin/greetings`);
          getGreetingStatus();
          setPageNum(1);
        } else if (res.data.status === 422) {
          setInputData({
            ...inputData,
            error_list: res.data.validation_errors,
          });
        } else {
          // swal("Error", res.data.message, "error");
        }
      });
    });
  };
  const declineNow = () => {
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.get(`/api/star/decline_greeting/${greeting.id}`).then((res) => {
        setLoading(false);
        if (res.data.status === 200) {
          swal("Success", res.data.message, "success");
          // history.push(`/superstar-admin/greetings`);
          getGreetingStatus();
          setPageNum(1);
        } else if (res.data.status === 422) {
          setInputData({
            ...inputData,
            error_list: res.data.validation_errors,
          });
        } else {
          // swal("Error", res.data.message, "error");
        }
      });
    });
  };

  return (
    <>
      {pageNum === 1 ? (
        <>
          <div className="row ">
            <div className="col-md-7">
              <div className="card card-bg p-2">
                {" "}
                <img
                  src={
                    greeting?.banner ? imageCdnUrl + greeting?.banner : noImage
                  }
                  alt=""
                  className="img-fluid"
                />
              </div>
            </div>
            <div className="col-md-5">
              <div className="card card-bg p-2">
                <ReactPlayer
                  url={greeting?.video ? videoCdnUrl + greeting?.video : ""}
                  width="100%"
                  height="330px"
                  playing={false}
                  volume={1}
                  controls={true}
                  autoPlay
                />
              </div>
            </div>
          </div>
          <div className="col-md-12 my-3">
            <div className="card card-bg shadow">
              <div className="card-body">
                <h5 className="text-light ">{greeting.title}</h5>

                <h5 className="text-warning">Instruction</h5>
                <div className="under-line"></div>
                <p className="text-light mt-2">
                  <Markup content={greeting.instruction} />
                </p>

                <div className="row mt-3">
                  <div className="col-sm-12 col-md-6 col-lg-3 mb-3 ">
                    <div className="d-flex  align-items-center bg-black  p-2  rounded-3 ">
                      <span>
                        <img src={PriceTag} alt="" className="PriceTage" />
                      </span>
                      <div className=" mx-2 ">
                        <span className="text-light buTon-ab ">Cost</span>
                        <br></br>
                        <span className="text-light buTon-abc fw-bolder">
                          {greeting?.cost} $
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-3 mb-3 ">
                    <div className="d-flex  align-items-center bg-black  p-2  rounded-3 ">
                      <span>
                        <img src={PriceTag} alt="" className="PriceTage" />
                      </span>
                      <div className=" mx-2 ">
                        <span className="text-light buTon-ab ">Share Cost</span>
                        <br></br>
                        <span className="text-light buTon-abc fw-bolder">
                          {greeting?.share_cost} $
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-3 mb-3">
                    <div className="d-flex b  align-items-center bg-black   p-2  rounded-3">
                      <span>
                        <img src={PriceTag} alt="" className="PriceTage" />
                      </span>
                      <div className=" mx-2 ">
                        <span className="text-light buTon-ab ">
                          Minimum apply before
                        </span>
                        <br></br>
                        <span className="text-info fw-bolder buTon-abc">
                          {greeting?.user_required_day} Day
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row ">
            <div className="row d-flex mx-a mt-4 mb-3">
              <div className="col-sm-12 col-md-3 col-lg-2 mb-3">
                {Number(greeting.star_approve_status) === 0 ? (
                  <>
                    {" "}
                    <button
                      onClick={() => approveNow()}
                      className="btn btnSave text-dark w-100 py-2 my-2 fw-bold me-3"
                    >
                      Approve <i className="fa-solid fa-check"></i>
                    </button>
                  </>
                ) : null}
              </div>
              <div className="col-sm-12 col-md-3 col-lg-2 mb-3">
                {Number(greeting?.status) < 2 ? (
                  <>
                    <button
                      onClick={() => setPageNum(2)}
                      className="btn btnEdit me-3 my-2 text-dark w-100 py-2  fw-bold"
                    >
                      Edit <i className="fa fa-edit"></i>
                    </button>
                  </>
                ) : null}
              </div>
              <div className="col-sm-12 col-md-3 col-lg-2 mb-3">
                {Number(greeting.star_approve_status) < 1 ? (
                  <>
                    {" "}
                    <button
                      onClick={() => declineNow()}
                      className="btn btnDecline text-dark my-2 w-100 py-2  fw-bold me-3"
                    >
                      Decline <i className="fa-solid fa-ban"></i>
                    </button>
                  </>
                ) : null}
              </div>
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
      {pageNum === 2 ? (
        <>
          <div className="text-light border border-warning rounded-3 d-flex justify-content-center p-2 my-3">
            <div className="faTrophy">
              <i className="fa-solid fa-calendar-plus"></i>
            </div>
            <h4 className="mx-3 text-warning p-2">
              Edit greetings information
            </h4>
          </div>

          <div className="card card-bg mb-2 p-2 ">
            <div className="card card-bg m-2">
              <div className="container-lg">
                <div className="row">
                  <div className="clo-sm-12 col-md-12 col-lg-9 mx-auto">
                    <form
                      onSubmit={greetingSubmit}
                      id="input_form"
                      encType="multipart/form-data"
                    >
                      <div className="row my-4">
                        <div className="col-md-3 label-text">
                          <p>
                            <>Title</>
                          </p>
                        </div>
                        <div className="col-md-9">
                          <input
                            className="form-control reply-control"
                            type="text"
                            onChange={handleInput}
                            name="title"
                            value={inputData.title}
                          />
                          <span className="text-danger">
                            {inputData.error_list.title}
                          </span>
                        </div>
                      </div>
                      <div className="row my-4">
                        <div className="col-md-3 label-text">
                          <p>
                            <>Instruction</>
                          </p>
                        </div>
                        <div className="col-md-9">
                          <CKEditor
                            data={convertedContent}
                            editor={ClassicEditor}
                            onChange={(event, editor) => {
                              setConvertedContent(editor.getData());
                            }}
                          />
                          <span className="text-danger">
                            {inputData.error_list.instruction}
                          </span>
                        </div>
                      </div>
                      <div className="row my-4">
                        <div className="col-md-3 label-text">
                          <p>
                            <>Cost</>
                          </p>
                        </div>
                        <div className="col-md-3">
                          <input
                            className="form-control reply-control"
                            type="number"
                            onChange={handleInput}
                            name="cost"
                            value={inputData.cost}
                          />
                          <span className="text-danger">
                            {inputData.error_list.cost}
                          </span>
                        </div>
                        <div className="col-md-3 label-text text-md-end">
                          <p>Share Cost</p>
                        </div>
                        <div className="col-md-3">
                          <input
                            className="form-control reply-control"
                            type="number"
                            placeholder="Enter share fee $"
                            onChange={handleInput}
                            name="share_cost"
                            value={inputData.share_cost}
                          />
                          <span className="text-danger">
                            {inputData.error_list.share_cost}
                          </span>
                        </div>
                        
                      </div>
                      <div className="row my-4">
                        <div className="col-md-3 text-warning">
                          <p>
                            <>Required day before date</>
                          </p>
                        </div>
                        <div className="col-md-3">
                          <input
                            className="form-control reply-control"
                            type="number"
                            onChange={handleInput}
                            name="user_required_day"
                            value={inputData.user_required_day}
                          />
                          <span className="text-danger">
                            {inputData.error_list.user_required_day}
                          </span>
                        </div>
                      </div>
                      <div className="row my-4">
                        <div className="col-md-3 label-text">
                          <p>
                            <>Upload Banner</>
                          </p>
                        </div>
                        <div className="col-md-9">
                        {fileUrl && file ? (
                            <div className="position-relative">

                              <img
                                src={fileUrl}
                                className="img-fluid avatar-img-src"
                                alt=""
                                style={{ maxHeight: "300px" }}
                              />
                              <span className="text-warning right-cross-button" onClick={deleteFile}>X</span>
                            </div>
                          ) : (
                            <img
                              src={imageCdnUrl + filePath}
                              className="img-fluid avatar-img-src"
                              alt=""
                              style={{ maxHeight: "300px" }}
                            />
                          )}
                          <input
                            type="file"
                            accept="image/jpg,image/jpeg, image/png"
                            className="inputfile"
                            onChange={(e) => bannerHandler(e.target.files)}
                            id="image"
                            name="image"
                            ref={fileInputRef}
                          />
                          {file && !fileUrl && <MediaUploadProgressBar progress={progress} />}
                          <label for="image">
                            <i className="fas fa-cloud-upload-alt"></i> Upload
                          </label>
                          <span className="text-danger">
                            {inputData.error_list.banner}
                          </span>
                        </div>
                      </div>
                      <div className="row my-4">
                        <div className="col-md-3 label-text">
                          <p>
                            <>Upload Video</>
                          </p>
                        </div>
                        <div className="col-md-9">
                        {videoUrl && video ? (
                            <div className="position-relative">
                              <ReactPlayer
                                url={videoUrl}
                                controls
                                playing={false}
                                volume={1}
                                width="100%"
                                height="200px" // style={{ margin: "0 auto" }}
                              />
                              <span className="text-warning right-cross-button" onClick={deleteVideo}>X</span>
                            </div>


                            ) : <ReactPlayer
                              url={videoCdnUrl + videoPath}
                              controls
                              playing={false}
                              volume={1}
                              width="100%"
                              height="200px" // style={{ margin: "0 auto" }}
                            />}

                          <input
                            type="file"
                            name="video"
                            id="video"
                            accept="video/mp4"
                            className="inputfile"
                            onChange={(e) => handleVideoChange(e.target.files)}
                            ref={videoInputRef}
                          />
                          {video && !videoUrl && <MediaUploadProgressBar progress={videoProgress} />}
                          <label for="video">
                            <i className="fas fa-cloud-upload-alt"></i> Upload
                          </label>
                          <span className="text-danger">
                            {inputData.error_list.video}
                          </span>
                        </div>
                      </div>

                      {/* Update Submit */}
                      <div className="row justify-content-center aligns-items-center my-4 mt-5">
                        <div className="col-md-3"></div>
                        <div className="col-sm-12 col-md-12 col-lg-9 d-flex justify-content-center aligns-items-center">
                          {/* <Link to={`/superstar/post/${params.id}`}>
                      <button className="btn btnGoBack fw-bold" type="submit">
                        Go Back
                      </button>
                    </Link> */}
                          {loading ? (
                            <>
                              <button className="btn btnUpdate">
                                <i className="fas fa-spinner fa-pulse"></i>{" "}
                              </button>
                            </>
                          ) : (
                            <button
                              className="btn btnUpdate fw-bold"
                              type="submit"
                            >
                              Update
                            </button>
                          )}
                        </div>
                      </div>
                      {/* Update Submit End */}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default NotifyGreetingsContent;
